import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {assertPolicyFilter, isPolicyFilter} from 'filters/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';

import {createTreeViewSection} from 'filters/features/FilterDialog/sections/TreeViewSection/TreeViewSection';
import {useProductTree} from 'modules/decisionsNext/hooks/trees/useProductTree';
import {useGroupedByLevelTreeViewSelection} from 'filters/features/FilterDialog/sections/TreeViewSection/selections/useGroupedByLevelTreeViewSelection';
import {openFilterDialog} from 'filters';
import {createCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/CounterItem';

import ProductsIcon from 'components/icons/metrics/products.svg';

const productLevels = [
  {
    key: 'productInsuranceSegmentIds',
    label: 'Insurance Segment',
  },
  {
    key: 'productSuperGroupIds',
    label: 'Super Group',
  },
  {
    key: 'productGroupIds',
    label: 'Group',
  },
  {
    key: 'productIds',
    label: 'Product',
  },
];

export const productsDialogSection = createTreeViewSection({
  id: FilterDialogSectionId.Products,
  title: 'Products',
  icon: ProductsIcon,
  useTreeData: useProductTree,
  useTreeSelection: useGroupedByLevelTreeViewSelection,
  getDataOptions: value => ({
    skip: Object.values(value).every(item => !item?.length),
  }),
  selectionOptions: {
    entity: 'Products',
    levels: productLevels,
  },
  getValue: filter => {
    assertPolicyFilter(filter);
    const {productInsuranceSegmentIds, productSuperGroupIds, productGroupIds, productIds} = filter;

    return {
      productInsuranceSegmentIds: productInsuranceSegmentIds ?? undefined,
      productSuperGroupIds: productSuperGroupIds ?? undefined,
      productGroupIds: productGroupIds ?? undefined,
      productIds: productIds ?? undefined,
    };
  },
  onChange: (filter, value) => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      ...value,
    };
  },
});

export const productsTopbarItem = createCounterItem({
  id: FilterTopbarItemId.Products,
  entity: 'Products',
  getCount: filter => {
    if (!isPolicyFilter(filter)) {
      return;
    }

    return [
      filter.productInsuranceSegmentIds,
      filter.productSuperGroupIds,
      filter.productGroupIds,
      filter.productIds,
    ].reduce((acc, item) => acc + (item?.length ?? 0), 0);
  },
  onClick: () => openFilterDialog(FilterDialogSectionId.Products),
  onReset: filter => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      productInsuranceSegmentIds: undefined,
      productSuperGroupIds: undefined,
      productGroupIds: undefined,
      productIds: undefined,
    };
  },
});
